import Brand from "../../../shared/components/Brand";
import Button from "../../../shared/components/Button";
import Input from "../../../shared/components/Input";
import LinearLayout from "../../../shared/components/LinearLayout";
import SecondaryIcon from "../../../shared/components/SecondaryIcon";
import Icons from "../../../shared/constants/icon.constant";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { useForgotPassword } from "../services";
import { isApiError } from "@/shared/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const { mutateAsync: forgotPassword, isPending } = useForgotPassword();

  const handleSubmit = async () => {
    if (!email) {
      toast.error("Please enter your email address");
      return;
    }

    try {
      await forgotPassword({ email });
      toast.success("Password reset link sent to your email");
      navigate("/reset-password", { state: { email } });
    } catch (error) {
      let message = "Unable to send reset link. Please try again.";
      let requestId: string | undefined;

      if (isApiError(error)) {
        message = error.message;
        requestId = error.requestId;
      } else if (error instanceof Error) {
        message = error.message;
      }

      toast.error(message, {
        description: requestId ? `Request ID: ${requestId}` : undefined,
      });
    }
  };

  return (
    <div className="px-6 flex flex-col items-center justify-between h-full">
      <Brand size="xl" />
      <div className="w-full">
        <LinearLayout orientation="vertical">
          <div className="text-center align-middle mx-auto space-y-5">
            <h1 className="text-white text-[20px] leading-[24px] font-medium ">
              Forgot Password
            </h1>
            <p className="text-white text-sm font-sm opacity-50">
              Enter your email and we’ll send you a password reset link.
            </p>
            <Input
              leftElement={
                <SecondaryIcon
                  icon={Icons.EmailIcon({ width: 17, height: 17 })}
                  isActive
                />
              }
              type="email"
              placeholder="name@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              fluid
            />
            <Button
              variant="primary"
              fluid
              onClick={handleSubmit}
              loading={isPending}
              disabled={isPending}>
              Send Reset Link
            </Button>
          </div>
        </LinearLayout>
      </div>
      <p className="text-center text-label-dark text-sm pb-10">
        Remember your password?{" "}
        <Link to="/sign-in" className="text-gray-200 underline">
          Sign in
        </Link>
      </p>
    </div>
  );
}
